import { render, staticRenderFns } from "./NetaNewView.vue?vue&type=template&id=2ca52aca&scoped=true&"
import script from "./NetaNewView.vue?vue&type=script&lang=js&"
export * from "./NetaNewView.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewView.vue?vue&type=style&index=0&id=2ca52aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca52aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca52aca')) {
      api.createRecord('2ca52aca', component.options)
    } else {
      api.reload('2ca52aca', component.options)
    }
    module.hot.accept("./NetaNewView.vue?vue&type=template&id=2ca52aca&scoped=true&", function () {
      api.rerender('2ca52aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/NetaNewView.vue"
export default component.exports